<template>
  <!-- For mobile viewport, show native date, time picker -->
  <label class="form-label" for="company-name">{{
    $t('product.subscribeToEventUpdatesModal.firstStep.form.companyName.label')
  }}</label>
  <div class="position-relative">
    <input
      id="company-name"
      v-model="form.companyName"
      autocomplete="company name"
      class="w-full border border-gray-200 rounded-lg p-2 bg-white mt-1"
      name="company-name"
      @input="$emit('clearErrors', 'name')"
    />

    <span class="block mb-2 text-xs text-gray-400">
      {{
        $t(
          'product.subscribeToEventUpdatesModal.firstStep.form.companyName.helperText'
        )
      }}
    </span>
  </div>
  <label class="form-label" for="city">{{
    $t('product.subscribeToEventUpdatesModal.firstStep.form.city.label')
  }}</label>
  <div class="position-relative">
    <input
      id="city"
      v-model="form.city"
      autocomplete="city"
      class="w-full border border-gray-200 rounded-lg p-2 bg-white mt-1"
      name="city"
      @input="$emit('clearErrors', 'city')"
    />
    <span class="block mb-2 text-xs text-gray-400">
      {{
        $t(
          'product.subscribeToEventUpdatesModal.firstStep.form.city.helperText'
        )
      }}
    </span>
  </div>
  <label class="form-label" for="privateRequestDate"
    >{{ $t('product.show.checkout.selectDate') }}
  </label>
  <div class="mt-1 relative w-full sm:hidden">
    <div class="relative w-full">
      <input
        id="privateRequestDate"
        v-model="form.dates[0]"
        :readonly="isMobile"
        :min="minDate"
        data-test-id="date-request-date-picker-1"
        step="1800"
        :placeholder="$t('product.show.checkout.selectDate')"
        type="datetime-local"
        class="w-full border border-gray-200 rounded-lg p-2 bg-white mt-1"
        name="privateRequestDate"
        @input="handleDateInput($event, 0)"
      />
    </div>
  </div>
  <div class="mt-1 relative w-full hidden sm:block">
    <Datepicker
      v-model="form.dates[0]"
      model-type="yyyy-MM-dd'T'HH:mm"
      time-picker-inline
      :format-locale="ja"
      format="dd.MM.yyyy, HH:mm"
      locale="de"
      select-text="auswählen"
      text-input
      minutes-increment="30"
      :start-time="startTime"
      :placeholder="$t('product.show.checkout.selectDate')"
      @open="$emit('clearErrors', 'dates')"
    />
  </div>
  <span class="block mb-2 text-xs text-gray-400">
    {{
      $t('product.subscribeToEventUpdatesModal.firstStep.form.date1.helperText')
    }}
  </span>

  <!-- Additional information textarea when request is not from event page -->
  <div v-if="!isFromEventPage" class="mt-4">
    <label class="form-label" for="additional-info">
      {{
        $t(
          'product.subscribeToEventUpdatesModal.firstStep.form.additionalInfo.label'
        )
      }}
    </label>
    <textarea
      id="additional-info"
      v-model="form.additionalInfo"
      :placeholder="
        $t(
          'product.subscribeToEventUpdatesModal.firstStep.form.additionalInfo.placeholder'
        )
      "
      class="w-full border border-gray-200 rounded-lg p-2 bg-white mt-1 h-24 resize-none"
      name="additional-info"
      @input="$emit('clearErrors', 'additionalInfo')"
    />
    <span
      v-if="invalidKeys.includes('additionalInfo')"
      data-test-id="date-request-form-invalid"
      class="text-red text-sm"
    >
      {{ errors.additionalInfo }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { roundToNearest30Minutes } from '~/utils/dateHelpers'
interface Props {
  eventData: EventDescription
  isFromEventPage?: boolean
  errors: DateRequestErrors
  invalidKeys: DateRequestInvalidKeys
}
withDefaults(defineProps<Props>(), {
  eventData: {},
  isFromEventPage: false,
  errors: {},
  invalidKeys: [],
})
const form = defineModel<any>()

function handleDateInput(event: Event, index: number) {
  const inputValue = event.target.value
  if (!inputValue) return
  const formatted = roundToNearest30Minutes(inputValue)
  if (formatted) {
    form.value.dates[index] = formatted
    event.target.value = formatted
  }
}
</script>
<style lang="postcss" scoped>
.required:after {
  content: '*';
  position: relative;
  font-size: inherit;
  @apply text-red;
  padding-left: 0.25rem;
  font-weight: 700;
}
:deep(.dp__input) {
  @apply rounded-lg;
}
</style>
